import { render, staticRenderFns } from "./FormsIndex.vue?vue&type=template&id=4bad40fa&scoped=true&"
import script from "./FormsIndex.vue?vue&type=script&lang=js&"
export * from "./FormsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad40fa",
  null
  
)

export default component.exports